// extracted by mini-css-extract-plugin
export var checkbox = "_26-0";
export var circle = "_26-3";
export var horizontalContainer = "_26-7";
export var sm = "_26-5";
export var switch0 = "_26-2";
export var switchDisabled = "_26-8";
export var switchEnabled = "_26-1";
export var textSwitchContainer = "_26-9";
export var textSwitchOption = "_26-a";
export var textSwitchOptionSelected = "_26-b";
export var verticalContainer = "_26-6";
export var xs = "_26-4";